var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "available-config" }, [
    _c("div", { staticClass: "d-flex flex-column" }, [
      _c("h4", { staticClass: "mt-2" }, [
        _vm._v(_vm._s(_vm.$t("fastWizard.channelAvailability"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hourContainer" }, [
        _c(
          "div",
          {
            staticClass: "hourItem",
            class: { selected: _vm.mode === "7/24" },
            on: {
              click: function ($event) {
                _vm.mode = "7/24"
              },
            },
          },
          [
            _c(
              "md-radio",
              {
                attrs: { value: "7/24" },
                model: {
                  value: _vm.mode,
                  callback: function ($$v) {
                    _vm.mode = $$v
                  },
                  expression: "mode",
                },
              },
              [_vm._v(_vm._s(_vm.$t("fastWizard.availability724")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "hourItem",
            class: { selected: _vm.mode === "agent-status-based" },
            on: {
              click: function ($event) {
                _vm.mode = "agent-status-based"
              },
            },
          },
          [
            _c(
              "md-radio",
              {
                attrs: { value: "agent-status-based" },
                model: {
                  value: _vm.mode,
                  callback: function ($$v) {
                    _vm.mode = $$v
                  },
                  expression: "mode",
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("fastWizard.basedOnTeam")) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "subtitle" }, [
              _vm._v(_vm._s(_vm.$t("fastWizard.basedOnTeamExplanation"))),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "hourItem",
            class: { selected: _vm.mode === "custom" },
            on: {
              click: function ($event) {
                _vm.mode = "custom"
              },
            },
          },
          [
            _c(
              "md-radio",
              {
                attrs: { value: "custom" },
                model: {
                  value: _vm.mode,
                  callback: function ($$v) {
                    _vm.mode = $$v
                  },
                  expression: "mode",
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("fastWizard.customHours")) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "subtitle private-time" }, [
              _vm._v(_vm._s(_vm.$t("fastWizard.customHoursExplanation"))),
            ]),
            _vm._v(" "),
            _vm.mode === "custom"
              ? _c(
                  "div",
                  { staticClass: "rules" },
                  [
                    _c(
                      "div",
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("fastWizard.customHoursTimezone"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-select",
                          {
                            staticStyle: { width: "250px" },
                            attrs: {
                              "show-search": "",
                              placeholder: "Select Timezone",
                              "option-filter-prop": "children",
                              "filter-option": _vm.filterOption,
                              value: _vm.timezone,
                            },
                            on: { change: _vm.changeTimezone },
                          },
                          _vm._l(_vm.timezones, function (tz, i) {
                            return _c(
                              "a-select-option",
                              { key: i, attrs: { value: tz } },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(tz) +
                                    "\n                            "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.rules, function (rule) {
                      return _c(
                        "div",
                        { staticClass: "ruleItem" },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "120px" },
                              attrs: {
                                "show-search": "",
                                placeholder: "Select Day(s)",
                                "option-filter-prop": "children",
                                "filter-option": _vm.filterOption,
                                value: _vm.daysHashcode(rule.days),
                              },
                              on: {
                                change: function (e) {
                                  return _vm.handleDayChange(e, rule._id)
                                },
                              },
                            },
                            _vm._l(_vm.days, function (day, i) {
                              return _c(
                                "a-select-option",
                                {
                                  key: i,
                                  attrs: { value: _vm.daysHashcode(day.value) },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(day.label[_vm.$i18n.locale]) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("fastWizard.customHoursFrom"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              staticStyle: {
                                width: "80px",
                                "margin-left": "10px",
                              },
                              attrs: {
                                "show-search": "",
                                placeholder: "Select Start Hour",
                                "option-filter-prop": "children",
                                "filter-option": _vm.filterOption,
                                value: rule.from,
                              },
                              on: {
                                change: function (e) {
                                  return _vm.handleFromHourChange(e, rule._id)
                                },
                              },
                            },
                            _vm._l(_vm.hours, function (hour, i) {
                              return _c(
                                "a-select-option",
                                { key: i, attrs: { value: hour } },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(hour) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("fastWizard.customHoursTo"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              staticStyle: {
                                width: "80px",
                                "margin-left": "10px",
                              },
                              attrs: {
                                "show-search": "",
                                placeholder: "Select End Hour",
                                "option-filter-prop": "children",
                                "filter-option": _vm.filterOption,
                                value: rule.to,
                              },
                              on: {
                                change: function (e) {
                                  return _vm.handleEndHourChange(e, rule._id)
                                },
                              },
                            },
                            _vm._l(_vm.hours, function (hour, i) {
                              return _c(
                                "a-select-option",
                                { key: i, attrs: { value: hour } },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(hour) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              staticClass:
                                "btnDelete d-flex align-items-center px-1 ml-2",
                              attrs: { disabled: _vm.rules.length === 1 },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteHour(rule._id)
                                },
                              },
                            },
                            [_c("ActionDelete")],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        staticClass: "btnAddHour",
                        attrs: { type: "primary", ghost: "" },
                        on: { click: _vm.addHour },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("fastWizard.customHoursAddHours")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }